import { render, staticRenderFns } from "./NotLoggedIn.vue?vue&type=template&id=ec894b24"
import script from "./NotLoggedIn.vue?vue&type=script&lang=js"
export * from "./NotLoggedIn.vue?vue&type=script&lang=js"
import style0 from "./NotLoggedIn.vue?vue&type=style&index=0&id=ec894b24&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports